<template>
  <div>
    <HeroHeader
      eyebrow="INQUILINO"
      :title="client.alias || client.name || '…'"
      :back="true"
      @back="$router.push('/tenants')"
      :compact="true"
    >
      <template #toolbar>
        <span v-if="client.id" class="badge" :class="client.state ? 'badge--success' : 'badge--error'">
          {{ client.state ? 'Activo' : 'Inactivo' }}
        </span>

        <!-- CTAs de Letras -->
        <template v-if="activeTab === 'bills' && client.id">
          <button class="btn btn--outline btn--sm"
                  @click="$refs.billsView.showGenerateSidebar = true">
            Generar
          </button>
          <button class="btn btn--outline btn--sm"
                  @click="$refs.billsView.showNotification = true">
            Notificar
          </button>
          <button class="btn btn--sm"
                  @click="$refs.billsView.showNewSidebar = true">
            + Agregar
          </button>
        </template>

        <!-- CTAs de Impuestos -->
        <template v-if="activeTab === 'taxes' && client.id">
          <button class="btn btn--outline btn--sm"
                  @click="$refs.taxesView.showGenerateSidebar = true">
            Generar
          </button>
          <button class="btn btn--sm"
                  @click="$refs.taxesView.showNewSidebar = true">
            + Agregar
          </button>
        </template>

        <!-- CTAs de Contratos -->
        <template v-if="activeTab === 'contracts' && client.id">
          <button class="btn btn--sm"
                  @click="$refs.contractsView.showNewSidebar = true">
            + Agregar
          </button>
        </template>
      </template>
    </HeroHeader>

    <!-- Solo doc + local — el nombre ya está en el hero title -->
    <div v-if="client.id" class="tenant-detail-meta">
      <span v-if="client.document" class="tenant-detail-meta__item">{{ client.document }}</span>
      <span v-if="client.document && client.local" class="tenant-detail-meta__sep">·</span>
      <span v-if="client.local" class="tenant-detail-meta__item">{{ client.local.description }}</span>
    </div>

    <TabBar :tabs="sectionTabs" v-model="activeTab"/>

    <BillsView ref="billsView" v-if="activeTab === 'bills'" :embedded="true" />
    <TaxesView ref="taxesView" v-if="activeTab === 'taxes'" :embedded="true" />
    <ContractsView ref="contractsView" v-if="activeTab === 'contracts'" :embedded="true" />
  </div>
</template>

<script>
import { db } from '@/firebase/firebaseConfig'
import BillsView from '@/views/bills/App'
import TaxesView from '@/views/taxes/App'
import ContractsView from '@/views/contracts/App'
import HeroHeader from '@/components/HeroHeader'
import TabBar from '@/components/TabBar'

export default {
  name: 'TenantDetail',
  components: { BillsView, TaxesView, ContractsView, HeroHeader, TabBar },
  data () {
    return {
      client: {},
      counts: { bills: null, taxes: null, contracts: null }
    }
  },
  computed: {
    activeTab: {
      get () {
        const tab = this.$route.query.tab
        return ['bills', 'taxes', 'contracts'].includes(tab) ? tab : 'bills'
      },
      set (val) {
        this.$router.replace({ query: { tab: val } })
      }
    },
    sectionTabs () {
      return [
        { label: 'Letras', value: 'bills', count: this.counts.bills },
        { label: 'Impuestos', value: 'taxes', count: this.counts.taxes },
        { label: 'Contratos', value: 'contracts', count: this.counts.contracts }
      ]
    }
  },
  async created () {
    const clientId = this.$route.params.id
    const doc = await db.collection('clients').doc(clientId).get()
    if (doc.exists) this.client = { id: doc.id, ...doc.data() }
    this.loadCounts(clientId)
  },
  methods: {
    async loadCounts (clientId) {
      try {
        const [bills, taxes, contracts] = await Promise.all([
          db.collection('clients').doc(clientId).collection('bills').get(),
          db.collection('clients').doc(clientId).collection('taxes').get(),
          db.collection('clients').doc(clientId).collection('contracts').get()
        ])
        this.counts.bills = bills.size
        this.counts.taxes = taxes.size
        this.counts.contracts = contracts.size
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.tenant-detail-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 6px 24px 0;
}

.tenant-detail-meta__name {
  font-size: 12px;
  color: #71717A;
  font-weight: 500;
}

.tenant-detail-meta__sep {
  font-size: 12px;
  color: #D4D4D8;
}

.tenant-detail-meta__item {
  font-size: 12px;
  color: #A1A1AA;
}
</style>
